import React from 'react';
import { BaseDefinitionsPopup } from './BaseDefinitionsPopup';
import { toneDefinitions } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/VoiceAndTone/VoiceAndTonePagePopup';

export const ToneDefinitionsPopup = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return <BaseDefinitionsPopup open={open} onClose={onClose} title="Tone Definitions" definitions={toneDefinitions} />;
};
